import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import FileUpload from '../common/FileUpload';
import { FileUploadQuestion } from './AssessmentQuestionType';
import AssessmentStepControButtonGroup from './AssessmentStepControlButtonGroup';
import {
  AssessmentQuestionAction,
  AssessmentQuestionActionType,
} from './AssessmentQuestionAction';
import APICaller, { MethodType } from '../common/APICaller';
import { useParams } from 'react-router-dom';
import FileDownload from '../common/FileDownload';

interface FileUploadQuestionStepProps {
  data: FileUploadQuestion;
  index: number;
  isLast: boolean;
  isFirst: boolean;
  goNext: () => void;
  goBack: () => void;
  handleSubmit: () => void;
  dispatch: React.Dispatch<AssessmentQuestionAction>;
}

const FileUploadQuestionStep: React.FC<FileUploadQuestionStepProps> = ({
  data,
  index,
  isLast,
  isFirst,
  goNext,
  goBack,
  handleSubmit,
  dispatch,
}) => {
  const { assessmentId } = useParams();
  
  const fileUploadHanlder = (file: File | null): void => {
    if (!file) {
      // User cancelled file selection - no action needed
      return;
    }

    const url = data.answerId
      ? `/application/assessments/answers/${data.answerId}/fileUpload/update`
      : `/application/assessments/questions/${data.id}/answer/fileUpload/create`;
    const method = data.answerId ? MethodType.PUT : MethodType.POST;

    const formData = new FormData();
    formData.append('file', file);
    APICaller(url, method, formData, true)
      .then(res => {
        console.log(res);
        if (!res.errorMessage) {
          if (res.answerId) {
            dispatch({
              type: AssessmentQuestionActionType.UpdateFileUpload,
              payload: {
                question_index: index,
                answer: file.name,
                answerId: res.answerId,
              },
            });
          } else {
            dispatch({
              type: AssessmentQuestionActionType.UpdateFileUpload,
              payload: {
                question_index: index,
                answer: file.name,
              },
            });
          }
          // Silent save - no notification
        }
      })
      .catch(e => {
        console.log(e);
      });
  };
  const handleNext = () => {
    goNext();
  };

  const handleBack = () => {
    goBack();
  };

  return (
    <>
      <Grid container>
        <Typography variant="h6">{data.description}</Typography>
        {data.hasQuestionFile && (
          <FileDownload
            url={`/assessments/${assessmentId}/question/${data.id}/file/download`}
            displayedText="Download Question"
            width="25%"
          />
        )}
        <FileUpload
          fileUploadHandler={fileUploadHanlder}
          buttonText={
            data.answerId ? 'Update your answer' : 'Upload your answer'
          }
          width="50"
        />
      </Grid>
      <AssessmentStepControButtonGroup
        isLast={isLast}
        isFirst={isFirst}
        handleNext={handleNext}
        handleBack={handleBack}
        handleSubmit={handleSubmit}
        showSaveBtn={false}
      />
    </>
  );
};

export default FileUploadQuestionStep;
